<template>
    <page>
        <module :title="id ? '编辑砍价活动' : '新建砍价活动'">
            <c-form ref="form">
                <c-form title="基础信息">
                    <c-form-item type="hidden" name="activity_id" v-model="activity_id" required></c-form-item>
                    <c-form-item type="input" label="活动名称"  name="activity_name"  maxlength="20" required></c-form-item>
                    <c-form-item type="datetime" label="活动时间" start-name="begin_date" end-name="end_date" required></c-form-item>
                    <c-form-item type="number" decimal="1" label="砍价有效期" :limit="[0.1,9999]" name="valid_time" required input-unit="时" word="即砍价发起后，必须在该时间内完成砍价，否则活动将失效"></c-form-item>
                    <c-form-item type="input" label="活动标签" name="tags"  maxlength="4"></c-form-item>
                  <!--                    <c-form-item type="radio" label="活动预告设置" value="-1"  name="activity_notice" v-model="activityNotice" :options="activityNoticeOptions" required word="活动预告期间，商品详情页价格上方将会展示活动标题，开始时间和折扣力度。" ></c-form-item>-->
<!--                    <c-form-item type="number" v-if="activityNotice == 1" decimal="1" :limit="[0.1,9999]" v-model="activityNoticeTime"  name="activity_notice_time" word="小时"></c-form-item>-->
                </c-form>

                <c-form title="活动商品">
                    <c-form-item>
                        <m-operate>
                            <c-button color="gray" hollow @click="$refs.productSelector.open()">添加商品</c-button>
                            <c-button color="gray" hollow @click="setLimit">批量填写最低价</c-button>
                            <c-button color="gray" hollow @click="setBargainUserLimit">批量设置砍价人数</c-button>
                            <c-button color="gray" hollow @click="setMinPriceOrderLimit">批量设置中途下单</c-button>
                        </m-operate>

                        <c-table ref="productList" v-model="productList" height="auto" :paging="false" border>
                            <c-table-column
                                    type="selector"
                            ></c-table-column>

                          <c-table-column
                              label="商品信息"
                              name="product_name"
                              width="250"
                          >
                            <template v-slot="{data}">
                              <div class="flex-center">
                                <c-image :src="oss(data.product_img_url, 46, 46)" size="46" preview></c-image>
                                <p class="flex-grow ellipsis-2" style="margin-left: 12px;">
                                    <span v-if="data.product_itemnumber">{{data.product_itemnumber}} - </span>
                                    {{data.product_name}}
                                </p>
                              </div>
                            </template>
                          </c-table-column>

                          <c-table-column
                              label="商品状态"
                              name="state"
                              width="80"
                          >
                            <template v-slot="{data}">
                              <span v-if="data.activity_product_id==null" style="color:gray">待保存</span>
                              <span v-if="data.activity_product_id && data.state == 0" style="color:red">结束</span>
                              <span v-if="data.activity_product_id && data.state == 1" style="color:green">正常</span>
                            </template>
                          </c-table-column>

                          <c-table-column
                                    label="现售价"
                                    name="product_price"
                                    width="130"
                            >
                                <template v-slot="{data}">￥{{data.product_price}}</template>
                            </c-table-column>

                            <c-table-column
                                    label="活动库存（单SKU）"
                                    width="120"
                            >
                                <template v-slot="{data}">
                                    <c-input  v-model="data.activity_stock_count" width="60" type="number" :limit="[1, 9999]"></c-input>
                                </template>
                            </c-table-column>

                            <c-table-column
                                    label="是否底价下单"
                                    name="min_price_order"
                                    width="110"
                            >
                                <template v-slot="{data}">
                                  <span v-if="data.min_price_order == 1" style="color:green">必须底价下单</span>
                                  <span v-if="data.min_price_order == 0" style="color:red">允许中途下单</span>
                                </template>
                            </c-table-column>

                            <c-table-column
                                    label="帮砍人数"
                                    width="80"
                            >
                                <template v-slot="{data}">
                                    <c-input  v-model="data.bargain_user_limit" width="60" type="number" :limit="[3, 999]" @change="ediBargainUserLimit(data)"></c-input>
                                </template>
                            </c-table-column>

                            <c-table-column
                                    label="帮砍底价"
                                    width="80"
                            >
                                <template v-slot="{data}">
                                    <c-input type="number" decimal="2" v-model="data.min_sale_price" :limit="[0, data.product_price]" width="60"  style="margin: 0 5px;"></c-input>
                                </template>
                            </c-table-column>

                            <c-table-column
                                    type="button"
                                    fixed="right"
                                    label="操作"
                                    width="140"
                            >
                                <template v-slot="row">
                                    <c-table-button v-if="id == null || row.data.activity_product_id==null" @click="row.remove()">删除</c-table-button>
                                    <c-table-button v-if="id && row.data.activity_product_id && row.data.state == 1" @click="over(row,0)">结束</c-table-button>
                                    <c-table-button v-if="id && row.data.activity_product_id && row.data.state == 0" @click="over(row,1)">开始</c-table-button>
                                    <c-table-button v-if="row.data.min_price_order == 0" @click="setSingleMinPriceOrderLimitHandle(row,1)">底价下单</c-table-button>
                                    <c-table-button v-if="row.data.min_price_order == 1" @click="setSingleMinPriceOrderLimitHandle(row,0)">中途下单</c-table-button>
                                </template>
                            </c-table-column>
                        </c-table>
                    </c-form-item>
                </c-form>
            </c-form>

            <template slot="button">
                <c-button v-show="editFlag" power="b_activity_bargain_edit" size="m" @click="submit()">提交保存</c-button>
            </template>
        </module>

        <c-dialog ref="limitDialog" title="批量设置最低价" width="400" height="150" @resolve="setLimitHandle">
            <c-form>
                <c-form-item  label="最低价" required>
                    <c-input  v-model="min_sale_price" decimal="2"  width="200" type="number" style="margin: 0 5px;"></c-input>
                </c-form-item>
            </c-form>
        </c-dialog>

        <c-dialog ref="bargainUserLimitDialog" title="批量设置帮砍人数" width="400" height="150" @resolve="setBargainUserLimitHandle">
            <c-form>
                <c-form-item  label="帮砍人数" required>
                    <c-input  v-model="bargain_user_limit" width="200" type="number" :limit="[3, 9999]" style="margin: 0 5px;"></c-input>
                </c-form-item>
            </c-form>
        </c-dialog>

        <c-dialog ref="minPriceOrderLimitDialog" title="批量设置中途下单" width="400" height="180" @resolve="setMinPriceOrderLimitHandle">
            <c-form>
                <c-form-item label="是否必须底价下单"  v-model="min_price_order"  type="select" :options="minPriceOrderOption" ></c-form-item>
            </c-form>
        </c-dialog>

      <product-selector ref="productSelector" multiple @resolve="productSelectHandle"></product-selector>
    </page>
</template>

<script>
    import productSelector from '@/components/service/product_selector.vue'
    export default {
        name: 'activity_bargain_edit',

        components: {
            productSelector
        },

        props: {
            id: String
        },

        data() {
            return {
                activityNoticeTime: 0,
                activityNotice: -1,
                activityNoticeOptions: [{
                  name: '立即预告',
                  value: 0
                },{
                  name: '不预告',
                  value: -1
                },{
                    name: '提前预告',
                    value: 1
                }],
                activityDiscountsOptions: [{
                    name: '叠加其他营销活动',
                    value: 1
                },{
                    name: '不叠加其他营销活动',
                    value: 2
                }],
                minPriceOrderOption: [
                    {
                    name: '必须底价下单',
                    value: 1
                    },{
                    name: '允许中途下单',
                    value: '0'
                }],
                purchaseLimitOptions: [{
                    name: '单次活动仅允许购买一件',
                    value: 1
                }],
                isSelfBargainOptions: [{
                    name: '允许自砍一刀',
                    value: 1
                }],
                isRandomReduceOptions: [{
                    name: '随机',
                    value: 1
                }],
                activity_id: '',
                min_sale_price: 0,
                bargain_user_limit: '',
                min_price_order: '',
                productList: [],
                editFlag: true,
            }
        },

        watch: {
            id() {
                this.getActivityDetail();
            },

            commodityRange(val) {
                if (val == 2) {
                    this.$refs.productList.resize();
                }
            }
        },

        mounted() {
            this.id && this.getActivityDetail();
        },

        methods: {
            getActivityDetail() {
                this.request({
                    url: '/activityBargain/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.$refs.form.set(data);
                        if(data.start_state == "1"){
                            this.editFlag = false;
                        }
                        this.activityNoticeTime = data.activity_notice_time;
                        this.productList = data.product_list;
                    }
                });
            },
            productSelectHandle(list) {
                list = list.filter(item => {
                    return !this.productList.find(row => {
                        return row.product_id == item.product_id;
                    });
                });
                list.forEach(item=>{
                    item.state = 1;
                    item.min_price_order = 1;
                })
                //检查商品时间是否和其他活动重叠
                this.productList = this.productList.concat(list);
            },
            over(row,state){
                row.data.state = state;
            },
            setLimit() {
                this._limit = this.$refs.productList.getRow('selected');
                if (!this._limit.length) {
                    this.$message({
                        text: '请选择商品'
                    });
                    delete this._limit;
                    return;
                }
                this.min_sale_price = 0;
                this.$refs.limitDialog.open();

            },
            setLimitHandle(stop) {
                if (!this.min_sale_price) {
                    stop();
                    this.$message({
                        text: '请填写最低价'
                    });
                    return;
                }
                this._limit.forEach(row => {
                    row.update({
                        min_sale_price: this.min_sale_price
                    });
                });
            },
            setBargainUserLimit(){
                this._limit = this.$refs.productList.getRow('selected');
                if (!this._limit.length) {
                    this.$message({
                        text: '请选择商品'
                    });
                    delete this._limit;
                    return;
                }
                this.bargain_user_limit = '';
                this.$refs.bargainUserLimitDialog.open();
            },
            setBargainUserLimitHandle(stop) {
                if (!this.bargain_user_limit) {
                    stop();
                    this.$message({
                        text: '请填写帮砍人数'
                    });
                    return;
                }
                this._limit.forEach(row => {
                    row.update({
                        bargain_user_limit: this.bargain_user_limit
                    });
                });
            },
            setMinPriceOrderLimit(){
                this._limit = this.$refs.productList.getRow('selected');
                if (!this._limit.length) {
                    this.$message({
                        text: '请选择商品'
                    });
                    delete this._limit;
                    return;
                }
                this.min_price_order = '';
                this.$refs.minPriceOrderLimitDialog.open();
            },
            setMinPriceOrderLimitHandle(stop) {
                if (!this.min_price_order) {
                    stop();
                    this.$message({
                        text: '请选择是否必须底价下单'
                    });
                    return;
                }
                this._limit.forEach(row => {
                    row.update({
                        min_price_order: this.min_price_order
                    });
                });
            },
            setSingleMinPriceOrderLimitHandle(row,state){
                row.data.min_price_order = state;
            },
	        ediBargainUserLimit(data){
		        var bargain_user_limit = data.bargain_user_limit?parseInt(data.bargain_user_limit):3;
				if (bargain_user_limit < 3){
					bargain_user_limit = 3;
				}else if (bargain_user_limit > 999){
					bargain_user_limit = 999;
				}
		        data.bargain_user_limit = bargain_user_limit;
	        },
            submit() {
                this.$refs.form.submit({
                    url: this.id ? '/activityBargain/edit' : '/activityBargain/add',
                    rule: {
                        activity_name: '请填写活动名称',
                        begin_date: '请选择活动时间',
                        valid_time: '请填写砍价有效期',
                        // user_level_ids: '请指定代理等级',
                        //share_title: '请填写分享标题',
                        //share_describe: '请填写分享助力语',
                        product_list: [{
                            type: 'function',
                            fun: () => {
                                return this.productList.length;
                            },
                            word: '请选择活动商品'
                        }],
                        product_config: [{
                            type: 'function',
                            fun: () => {
                                return !this.productList.find(item => {
                                    return !item.min_sale_price || item.min_sale_price==0;
                                });
                            },
                            word: '请设置砍价底价'
                        }],
                        bargain_user_config: [{
                            type: 'function',
                            fun: () => {
                                return !this.productList.find(item => {
                                    return !item.bargain_user_limit || item.bargain_user_limit==0;
                                });
                            },
                            word: '请设置帮砍人数'
                        }],
                        activity_stock_count: [{
                            type: 'function',
                            fun: () => {
                                return !this.productList.find(item => {
                                    return !item.activity_stock_count || item.activity_stock_count==0;
                                });
                            },
                            word: '请设置砍价活动库存'
                        }]
                    },

                    dataFormatter: data => {
                        this.id && (data.id = this.id);

                        data.product_list = Array.from(this.productList, item => {
                            return {
                                product_id: item.product_id,
                                product_name: item.product_name,
                                min_sale_price: Number.parseFloat(item.min_sale_price),
                                bargain_user_limit: Number.parseInt(item.bargain_user_limit),
                                min_price_order: item.min_price_order,
                                activity_stock_count: parseInt(item.activity_stock_count),
                                state: item.state
                            }
                        });
                        return data;
                    },

                    success: (data,obj) => {
                        if(obj != null && obj.length !=0){
                            var res = "【";
                            obj.forEach(item=>{
                                res+=item+","
                            })
                            res = res.substring(0,res.length-1);
                            res+="】"

                            this.$message({
                                text: '保存成功,存在以下商品和其他活动时间冲突未能添加成功'+res.toString(),
                            });
                        }else{
                            this.$message({
                                text: "保存成功",
                            });
                        }
                        this.$bus.$emit('activityBargainList.update');
                        this.redirectTo('/activity_bargain');
                    }
                })
            }
        }
    }
</script>

<style lang="stylus" scoped>
  .limit {
    .item {
      margin-right: 16px;

      label {
        margin-right: 8px;
      }
    }
  }
</style>